import React from 'react';

/** @internal */
export var listIconElement = /*#__PURE__*/React.createElement("svg", {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.84375 11.75H1.28125C0.849609 11.75 0.5 12.0996 0.5 12.5312V14.0938C0.5 14.5254 0.849609 14.875 1.28125 14.875H2.84375C3.27539 14.875 3.625 14.5254 3.625 14.0938V12.5312C3.625 12.0996 3.27539 11.75 2.84375 11.75Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.7188 12.5312H8.3125C7.88086 12.5312 7.53125 12.8809 7.53125 13.3125C7.53125 13.7441 7.88086 14.0938 8.3125 14.0938H24.7188C25.1504 14.0938 25.5 13.7441 25.5 13.3125C25.5 12.8809 25.1504 12.5312 24.7188 12.5312Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.84375 18H1.28125C0.849609 18 0.5 18.3496 0.5 18.7812V20.3438C0.5 20.7754 0.849609 21.125 1.28125 21.125H2.84375C3.27539 21.125 3.625 20.7754 3.625 20.3438V18.7812C3.625 18.3496 3.27539 18 2.84375 18Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.7188 18.7812H8.3125C7.88086 18.7812 7.53125 19.1309 7.53125 19.5625C7.53125 19.9941 7.88086 20.3438 8.3125 20.3438H24.7188C25.1504 20.3438 25.5 19.9941 25.5 19.5625C25.5 19.1309 25.1504 18.7812 24.7188 18.7812Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.84375 5.5H1.28125C0.849609 5.5 0.5 5.84961 0.5 6.28125V7.84375C0.5 8.275 0.849609 8.625 1.28125 8.625H2.84375C3.27539 8.625 3.625 8.275 3.625 7.84375V6.28125C3.625 5.84961 3.27539 5.5 2.84375 5.5Z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.3125 6.28125C7.88086 6.28125 7.53125 6.63086 7.53125 7.0625C7.53125 7.49414 7.88086 7.84375 8.3125 7.84375H24.7188C25.1504 7.84375 25.5 7.49414 25.5 7.0625C25.5 6.63086 25.1504 6.28125 24.7188 6.28125H8.3125Z"
}));